import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import { SPACING, TYPOGRAPHY } from "@store/theme/common/design";
import { contentSpacingStyles } from "@store/theme/common/mixins/common";
import { transitionHoverStyles } from "@store/theme/common/mixins/transition";
import { css } from "styled-components";

export const titleSpacingStyles = () => {
    return contentSpacingStyles("1em", "0.5em");
};

export const linkStyles = (color = "text.link", hoverColor = "text.linkHover") => {
    return css`
        ${transitionHoverStyles("color")}
        color: ${getColor(color)};

        &:active,
        &:visited {
            color: ${getColor(color)};
        }

        &:hover {
            color: ${getColor(hoverColor)};
            text-decoration: underline;
        }
    `;
};

export const editLinkStyles = () => {
    return css`
        ${getProp("theme.link.defaultProps.css")}
        font-size: ${TYPOGRAPHY.size.smaller};
        font-weight: ${TYPOGRAPHY.weight.bold};
    `;
};

export const labelSeparationStyles = () => {
    return css`
        position: relative;
        padding-right: 11px;
        margin-right: 10px;

        &::after {
            content: "";
            position: absolute;
            top: 50%;
            right: 0;
            width: 1px;
            height: 0.8em;
            background-color: ${getColor("common.borderDark")};
            transform: translateY(-50%);
        }

        &:last-child::after {
            display: none;
        }
    `;
};

export const checkoutBlockTitleStyles = () => {
    return css`
        margin-bottom: ${SPACING.standard};
        font-size: ${TYPOGRAPHY.size.large} !important;
        font-weight: ${TYPOGRAPHY.weight.bold};
        color: ${getColor("text.titles")};
    `;
};

export const checkoutBlockSubTitleStyles = () => {
    return css`
        margin-bottom: ${SPACING.xsmall};
        font-size: ${TYPOGRAPHY.size.small} !important;
        font-weight: ${TYPOGRAPHY.weight.bold};
        color: ${getColor("text.titles")};
    `;
};

export const orderLinesHeadingStyles = () => {
    return css`
        align-items: center;
        padding: 0 20px;
        text-transform: uppercase;
        font-weight: ${TYPOGRAPHY.weight.bold};
        color: ${getColor("secondary.contrast")};

        &.centered {
            justify-content: center;
            padding: 0 10px;
        }
    `;
};
